import React from "react";
import ai6 from '../../assets/ai6.png';
import ai7 from '../../assets/ai7.png';
import ai8 from '../../assets/ai8.jpg';
import ai9 from '../../assets/ai9.jpg';
import ai10 from '../../assets/ai10.jpg';
import ai11 from '../../assets/ai11.jpg';

const A2 =() =>{
return(
    <div className='page1'>
    <div className='overall'>
      <h2 className='heading'>தாய்ப்பால் ஊட்டுதல்</h2>
      <h3 className='subheading'>தாய்ப்பாலை வெளிப்படுத்துவது எப்படி?</h3>

    </div>
      <div className='answer'>
   
     
      <h3  style={{ color: '#BB0297' }}>தாய்ப்பாலை வெளிப்படுத்தும் முறை</h3><br></br>

      <img src={ai6}  className='image' alt=""/>
      <br /> <br />
      <h4  style={{ color: '#BB0297' }}>கையால் தாய்ப்பாலை வெளிப்படுத்தும் முறை:</h4>
      <img src={ai7}  className='image' alt=""/>

      கையால் தாய்ப்பாலை வெளிப்படுத்துவது ஒரு திறமையாகும், தாய்ப்பாலை கையால் வெளிப்படுத்த கீழ்வரும் வழிமுறைகளை பின்பற்ற வேண்டும். வெளிப்படுத்தும் பாலை சேமிக்க ஒரு பாட்டில், கோப்பை அல்லது கிண்ணம் தயாராக இருக்க வேண்டும். தாய்ப்பாலை கையால் வெளிப்படுத்துவதற்கான படிப்படியான வழிமுறைகள்;
<ul>
  <br />
    <li>சோப்பு மற்றும் தண்ணீருடன் உங்கள் கைகளை கழுவவும்.</li>
 <br />
 <li>ஒரு வசதியான நிலையை எடுத்து ஓய்வெடுக்க முயற்சி செய்யுங்கள்.</li>
 <br />
 <li>உங்கள் மார்பகங்களில் சூடான துண்டை வைக்கவும் அல்லது மார்பகங்களை மெதுவாக மசாஜ் செய்ய வேண்டும்.</li>
</ul>
<br />
<ul>
 <li>சி- வடிவில் உங்கள் மார்பில் உங்கள் கையை வைக்க வேண்டும். அதாவது, உங்கள் கட்டைவிரலை மார்பகத்தின் மேல் மற்றும் உங்கள் விரல்களை மார்பகத்தின் கீழ் வைக்கவும். உங்கள்
கட்டைவிரல் மற்றும் உங்கள் விரல்கள் முலைக்காம்புக்கு 1 முதல் 2 அங்குலங்கள் பின்னால் இருக்க வேண்டும். </li>
<br />
<li>ஒரு சுத்தமான சேகரிப்பு கோப்பை அல்லது மார்பக பால் சேமிப்பு பாட்டிலை உங்கள் மார்பகத்தின் கீழ் உங்கள் மற்றொரு கையால்
பிடிக்கவும், இதனால் உங்கள் முலைக்காம்பு நேரடியாக மேலே
இருக்கும்.</li>
<br />
</ul>
<img src={ai8}  className='image' alt=""/>
<br />
<ul>
<li>உங்கள் கட்டைவிரல் மற்றும் விரல்களால் உங்கள் மார்பகத்தை உங்கள் உடலை நோக்கி மெதுவாக தள்ளத் தொடங்க வேண்டும்.</li> 
<br />
<li> உங்கள் கட்டைவிரலையும் விரல்களையும் ஒன்றாக இணைக்க வேண்டும். பின்னர், உங்கள் தொடக்க நிலையை நோக்கி உங்கள் கையை முன்னோக்கி நகர்த்தும்போது உருட்டல் இயக்கத்தைப் பயன்படுத்த வேண்டும். மென்மையான உருட்டல் இயக்கமானது தாய்ப்பாலை பால் குழாய்களில் இருந்து வெளியேற்றும்.</li>
</ul>
<br />
<img src={ai9}  className='image' alt=""/>
<ul>
  <br />
<li>உங்கள் முலைக்காம்பிலிருந்து சொட்டு சொட்டாக வரும் தாய்ப்பாலை சேகரிக்க சிறிது முன்னோக்கி சாய்ந்து கொள்ள வேண்டும். முதலில் வரும் பால் எதுவும் உங்கள் கைகளைக் தொடாமல் உங்கள் சேகரிப்பு கொள்கலனில் தாய்ப்பாலை சேகரிக்க வேண்டும்.</li>
<br />
<li>ஒரு மார்பகத்தில் முழுமையாக முடித்த பிறகு தான் அடுத்த மார்பத்திற்கு மாற்ற வேண்டும்.</li>
<br />
<img src={ai10}  className='image' alt=""/>
<br /><br />
<li>நீங்கள் வெளிப்படுத்திய பாலை உடனடியாக உங்கள் குழந்தைக்குக் கொடுங்கள் அல்லது தாய்ப்பாலைச் சேகரிக்கும் பையில் அல்லது கொள்கலனில் அடைத்து, பின்னர் பயன்படுத்த சேமித்து வைக்க வேண்டும்.</li>
</ul>
<br></br>
<br></br>
<h3  style={{ color: '#BB0297' }}>பிரெஸ்ட் பம்ப் பயன்படுத்தும் முறை:-</h3>
<br />
<img src={ai11}  className='image' alt=""/>
<br /><br />
<h4>எந்தெந்த நேரங்களில் பிரெஸ்ட் பம்ப் பயன்படுத்தலாம்?</h4>
<br/>
1. தாயால் குழந்தைக்குத் தாய்ப்பால் கொடுக்க முடியாத அளவுக்கு உடல்நிலை பாதிப்பு இருந்தால்
<br/><br/>
2. பிறந்த குழந்தை தாயிடம் இருந்து தனித்து வைக்கப்பட்டு இருக்கும்போது (குறை பிரசவம் அல்லது வேறு மருத்துவக் காரணங்களால்)
<br /><br/>
3. தாய்க்கு தேவைக்கும் அதிகமாக பால் சுரக்கும்போது
<br /><br/>
4. பணிக்குச் செல்வது, தூக்கத்தை தவிர்க்க இயலாத சூழ்நிலை போன்ற காரணங்கள்
<br /><br/><br/>
<h4>பிரெஸ்ட் பம்ப் பயன்படுத்துவது எப்படி?</h4>
<ul>
<br/>
<li> பம்ப்பை பயன்படுத்தும் முன் கைகள், மார்பகங்கள், மற்றும் எலக்ட்ரிக் பம்ப்பை நன்றாகச் சுத்தம்செய்து கொள்ள வேண்டும்.</li>
<br/>
<li>எலக்ட்ரிக் பம்ப்பின் பிரெஸ்ட் ஷீல்டு (breast shield), டியூப் (tube) உடன் கூடிய கருவியை ஒன்றாக இணைத்துக் கொள்ள வேண்டும்.</li>
<br/>
<li> பின் எலெக்ட்ரிக் பம்பில் கொடுக்கப்பட்டுள்ள breast shield-ஐ மார்பகத்தில் பொருத்திக்கொள்ளவும். முன்னதாக, டியூபின் அளவு மார்புக்காம்பை விட 3 - 4 மில்லிமீட்டர் அகலமாக இருப்பதாக கவனித்து வாங்கிக்கொள்ள வேண்டும்.</li>
<br/>
<li>தயார் நிலைக்கு வந்த பின், கருவியில் கொடுக்கப்பட்டுள்ள வேகத்தினை கவனித்து உங்களுக்கு எந்த வேகம் சரியாக இருக்குமோ அதற்கேற்ப பம்ப்பை இயக்க வேண்டும்.</li>
<br/>
<li>பம்ப் செயல்பட்டு தாய்ப்பால் மெஷினுடன் இணைக்கப்பட்டுள்ள பாட்டிலில் சேகரமாகிவிடும். அதனை எடுத்துப் பயன்படுத்தலாம்.</li>
</ul>
</div>
</div>
)

}
export default A2;
